import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  value: string;
  onOpenChange: (open: boolean) => void;
  onChange: (value: string) => void;
}

export function LobbySearch({ open, value, onOpenChange, onChange }: Props) {
  const { t } = useTranslation('games');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (open) inputRef.current?.focus();
  }, [open]);

  return (
    <div className={`lobby-search${open ? ' open' : ''}`}>
      <button
        type="button"
        className="lobby-search-toggle"
        aria-label={t('searchPlaceholder')}
        aria-expanded={open}
        onClick={() => onOpenChange(!open)}
      >
        ⌕
      </button>
      {open ? (
        <label className="search-bar lobby-search-field">
          <span className="sr-only">{t('searchPlaceholder')}</span>
          <input
            ref={inputRef}
            type="search"
            value={value}
            placeholder={t('searchPlaceholder')}
            onChange={(event) => onChange(event.target.value)}
            autoComplete="off"
          />
          <button
            type="button"
            className="lobby-search-close"
            aria-label="Close"
            onClick={() => {
              onChange('');
              onOpenChange(false);
            }}
          >
            ×
          </button>
        </label>
      ) : null}
    </div>
  );
}
